"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var use_translations_hook_1 = __importDefault(require("../../context/translations/use-translations.hook"));
var styled_components_1 = __importDefault(require("styled-components"));
var ErrorMessage = styled_components_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.error.color;
});
var Error = function () {
    var getTranslation = use_translations_hook_1.default().getTranslation;
    return react_1.default.createElement(ErrorMessage, { "data-test-id": "error-message" }, getTranslation('GLOBAL:ERROR'));
};
Error.displayName = 'Error';
exports.default = Error;
var templateObject_1;
//# sourceMappingURL=error-message.component.js.map